/** Date helpers shared by the promo code dialogs. Codes store `expiresAt` as unix seconds. */

/** Convert a `<input type="datetime-local">` value to unix seconds, or null if unparseable. */
export function dateTimeLocalToUnix(value: string): number | null {
  if (!value) return null;
  const ms = new Date(value).getTime();
  if (!Number.isFinite(ms)) return null;
  return Math.floor(ms / 1000);
}

/** Convert unix seconds to a `<input type="datetime-local">` value in the local timezone. */
export function unixToDateTimeLocal(unix: number | null | undefined): string {
  if (!unix || !Number.isFinite(unix)) return '';
  const d = new Date(unix * 1000);
  if (Number.isNaN(d.getTime())) return '';
  // datetime-local needs YYYY-MM-DDTHH:mm in local time (no timezone suffix).
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** Human-readable date for table cells; em dash when unset. */
export function formatPromoDate(unix: number | null | undefined): string {
  if (!unix || !Number.isFinite(unix)) return '—';
  const d = new Date(unix * 1000);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString([], { year: 'numeric', month: 'short', day: 'numeric' });
}
